module.exports = __webpack_public_path__ + "img/sup_kyc_banner.3afbdefb.jpg";